import { Div, Icon, Label, X, lightTheme } from '@vgrubs/components';
import styled from 'styled-components';
import CurrencyInput2 from './currencyInput2';

const AdminInputStyled = styled(CurrencyInput2)`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.darkGray}80;
  border-radius: 200px;
  font-size: ${({ theme }) => theme.input.fontSize};
  line-height: 18px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: ${({ theme }) => theme.input.height};
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  background: none;

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  ${({ shadowDesign, theme }) =>
    shadowDesign &&
    `
  
  border: 1px solid #e3e3e3;
  box-shadow: ${theme.shadows.shadow1};
  `}

  ${({ $bigRed, theme }) =>
    $bigRed &&
    `
  
  color: ${theme.primary};
  font-size: 25px;
  font-weight: 700;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
  `}

  ${({ search }) => search && `padding-right: 50px`};
  ${({ $textCenter }) => $textCenter && `text-align: center`};

  ${({ $color }) => $color && `color: ${$color}`};

  ${({ $small }) => $small && `height: 32px; padding: 0 12px;`};

  :focus {
    outline: none !important;
    border: 1px solid ${({ theme }) => theme.primary};
  }

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

const IconStyledClear = styled.div`
  position: absolute;
  right: 18px;
  left: auto;
  bottom: 9px;
  transform: translate(0, -50%);
  z-index: 1;
  height: 12px;
  cursor: pointer;
`;

export const AdminDollarInput2 = (inputProps) => {
  const { onClickClear, ...props } = inputProps || {};
  const random = Math.random().toString();
  return (
    <Div
      $relative
      $width="100%"
      $maxWidth={props?.maxWidth}
      $maxWidthSM={props?.maxWidthSM}
    >
      {props.label && (
        <Label
          label={props.label}
          tooltip={props.tooltip}
          $textCenter={props.$textCenter}
        />
      )}
      <AdminInputStyled {...props} />

      {onClickClear !== undefined && props.value !== null && (
        <IconStyledClear
          onClick={(e) => {
            e.stopPropagation();
            onClickClear?.(e);
          }}
        >
          <Icon $pointer $size="12">
            <X fill={lightTheme.darkGray} />
          </Icon>
        </IconStyledClear>
      )}
    </Div>
  );
};
